import Frame from "../components/Frame";
import { PlayIcon } from "../components/Icons";
import RetryPanel from "../components/RetryPanel";
import ui from "../components/ui.module.css";

const YourTurn = ({ retry, saving }) => (
  <Frame centered>
    <span className={`${ui.bigIcon} ${ui.bigIconGold} ${ui.pop}`}>
      <PlayIcon size={72} />
    </span>
    <h1 className={`${ui.learnerTitle} ${ui.pop}`}>Your turn!</h1>
    {retry && <RetryPanel onRetry={retry} saving={saving} />}
  </Frame>
);

export default YourTurn;
